import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sortBy: 'date',
  search: '',
  searchOpen: false,
};

export const assetsLiabilitiesSortFilterSlice = createSlice({
  name: 'assetsLiabilitiesSortFilter',
  initialState,
  reducers: {
    setSortBy: (state, { payload }) => {
      state.sortBy = payload;
    },
    setSearch: (state, { payload }) => {
      state.search = payload;
    },
    toggleSearchOpen: (state) => {
      state.search = '';
      state.searchOpen = !state.searchOpen;
    },
  },
});

export const { setSortBy, setSearch, setSearchOpen, toggleSearchOpen } =
  assetsLiabilitiesSortFilterSlice.actions;

export default assetsLiabilitiesSortFilterSlice.reducer;
